/**
 * 検索ページのテーブルを整形や、スクロールの制御を担う
 * @returns { void }
 */
export const searchTable = () => {
  const tableItems = document.querySelectorAll( '.p-search-table' );

  tableItems.forEach( tableItem => {
    const tableController      = tableItem.querySelector( '.p-search-table__controller' );
    const tableBody            = tableItem.querySelector( '.p-search-table__body' );
    const tableHeaders         = tableItem.querySelectorAll( '.p-search-table__head' );
    const tableControllerWidth = tableController.getAttribute( 'data-controller-width' );
    const tableCellHeight      = tableItem.getAttribute( 'data-cell-height' );

    /**
     * 横幅をセット
     */
    tableController.style.width = tableControllerWidth + 'px';
    tableBody.style.width = 'calc(100% - ' + tableControllerWidth + 'px';

    if ( tableControllerWidth == 0 ) {
      tableController.style.border = 'none';
    }

    let totalWidth = 0;
    const bodyWidth = tableBody.clientWidth;

    tableHeaders.forEach( ( tableHeader, index ) => {
      totalWidth += Number(tableHeader.getAttribute( 'data-width' ));
      const width = tableHeader.getAttribute( 'data-width' ) - 16; // 16は margin の大きさ
      tableHeader.style.minWidth = width + 'px';
      tableHeader.style.width = width + 'px';

      const items = tableItem.querySelectorAll( '.p-search-table__item:nth-of-type(' + ( index + 1 ) + ')' );
      items.forEach( item => {
        item.style.minWidth = width + 16 + 'px';
        item.style.width = width + 16 + 'px';
        if ( tableCellHeight !== null ) {
          item.style.minHeight = tableCellHeight + 'px';
        }
      } );

      if ( tableHeader.getAttributeNames().includes( 'data-width-auto' ) ) {
        tableHeader.style.width = '100%';
        items.forEach( item => {
          item.style.width = '100%';
        } );
      }
    } );

    /**
     * スクロール処理
     */
    const scroll1 = tableItem.querySelector( '.p-search-table__scroll.is--controller' );
    const scroll2 = tableItem.querySelector( '.p-search-table__header.is--scroll' );
    const scroll3 = tableItem.querySelector( '.p-search-table__scroll.is--body' );

    const scrollHint = tableItem.querySelector( '.scroll-hint-icon-wrap' );

    scroll1.addEventListener( 'scroll', ( e ) => {
      const scrollY = e.target.scrollTop;
      scroll3.scrollTop = scrollY;
      scrollHint.style.opacity = 0;
    } );

    scroll2.addEventListener( 'scroll', ( e ) => {
      const scrollX = e.target.scrollLeft;
      scroll3.scrollLeft = scrollX;
      scrollHint.style.opacity = 0;
    } );

    scroll3.addEventListener( 'scroll', ( e ) => {
      const scrollX = e.target.scrollLeft;
      const scrollY = e.target.scrollTop;
      scroll1.scrollTop = scrollY;
      scroll2.scrollLeft = scrollX;
      scrollHint.style.opacity = 0;
    } );

    /**
     * 横スクロールがない場合は、scroll hintを隠す
     */
    if ( bodyWidth + 11 > totalWidth ) {
      scrollHint.style.opacity = 0;
    } else {
      const tableList = tableItem.querySelectorAll( '.p-search-table__list' );
      tableList.forEach( item => {
        item.style.width = totalWidth + 'px';
      } );
    }
  } );
}
